import { render, staticRenderFns } from "./ShareDeck.vue?vue&type=template&id=55147fab&"
import script from "./ShareDeck.vue?vue&type=script&lang=js&"
export * from "./ShareDeck.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports